export default __webpack_public_path__ + "static/compareItemImg3-99ce03c3e11ece087a0e780c4e819189.webp";